import { render } from "./PeerReviewSectionV2.vue?vue&type=template&id=d6eb47b8"
import script from "./PeerReviewSectionV2.vue?vue&type=script&lang=js"
export * from "./PeerReviewSectionV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__